import { useTranslation } from 'react-i18next'

import { OrderItem } from '../../redux/order'

export const CartItemError = (record: OrderItem) => {
  const { t } = useTranslation(['cartItem'])
  return record.errorCode === '110ZCC'
    ? t('cartItem:ProductNotInContract')
    : record.errorCode === '179ZCC'
      ? t('cartItem:ConsumptionLimitText')
      : t('cartItem:Error')
}
